const envBase =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  '';

const isValidHttpUrl = (value) => /^https?:\/\//i.test(String(value || ''));

const normalizeBase = (value) => String(value || '').trim().replace(/\/+$/, '');

const currentAppBase = () => `${window.location.origin}/menu-digitale`;

const isLocalHostname = () => {
  const host = (window.location.hostname || '').toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
};

const resolveAppBase = () => {
  const sameOriginBase = normalizeBase(currentAppBase());

  // In produzione il frontend deve sempre parlare con il dominio corrente.
  if (!isLocalHostname()) {
    return sameOriginBase;
  }

  if (isValidHttpUrl(envBase)) {
    return normalizeBase(envBase);
  }

  if (envBase) {
    return normalizeBase(envBase);
  }

  return sameOriginBase;
};

export const APP_BASE = resolveAppBase();
export const API_BASE = `${APP_BASE}/api/public`;
export const API = API_BASE;
